import { useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import { MessageToPermissionLevelNeeded } from "../types/Auth";
import { PageKey, PAGES_ACCESS_REQUIRED_LEVEL } from "../types/Pages";

const useCanAccess = () => {
    const { userInfo } = useAuth();
    const { activeLocation } = useAuth();
    const rolelevel = activeLocation?.rolelevel || 0;

    const canAccessPage = useCallback((page: PageKey): boolean => {
        const requiredRole = PAGES_ACCESS_REQUIRED_LEVEL[page];
        return rolelevel >= requiredRole;
    }, [rolelevel]);

    const canAccessAction = useCallback((action: keyof MessageToPermissionLevelNeeded): boolean => {
        return rolelevel >= userInfo!.mapMessageToPermissionLevelNeeded[action];
    }, [rolelevel, userInfo]);

    return { canAccessPage, canAccessAction };
};

export default useCanAccess;